const en = {
  //Common
  cancel: "Cancel",
  search: "Search",
  accept: "OK",
  continue: "Next",
  back: "Back",
  noData: "No data",
  apply: "Apply",
  of: "Of",
  yes: "Yes",
  seconds: "Seconds",
  requiredData: "Required data",
  showReference: "Show reference",
  loading: "Loading...",
  //Login
  loginCard: "Login",
  selectUser: "Select",
  login: "Login",
  user: "User",
  pass: "Password",
  spa: "Spanish",
  eng: "English",
  access: "ACCESS",
  rights: "All rights reserved.",
  level: "Level",
  ref: "Reference",
  status: "Status",
  rows: "Rows per page",
  invalidUs: "Invalid data",
  invalidPass: "Invalid password",
  invalidEmail: "Enter a valid email address",
  invalidPhone: "Enter a valid phone number",
  tryAgain: "Invalid user. try again.",
  loginErr: "Connection cannot be established, try later",
  rememberme: "Remember me",
  invalidUser: "No privileges to enter",
  subheader: "Available access profiles",
   //MAP
   mapCoordinatesError: "It was not possible to show on map given the data provided.",
  //Reports
  deleteConfirm: "Are you sure to delete the selected report?",
  inprocess: "Working...",
  delete: "Delete",
  download: "Download",
  new: "New report",
  name: "Name",
  date: "Date created",
  col: "Columns",
  vehicles: "Vehicles",
  type: "Report type",
  periodTitle: "Period",
  periodOfEvents: "Period of events",
  selectAll: "Select all",
  available: "Available vehicles",
  noResults: "No results found",
  asist: "New report wizard",
  commandSetting: "Commands setup",
  titleDes: "Performance report",
  nameReport: "File name",
  period: "Report period",
  selectV: "Selected vehicles",
  sendEmail: "Send email",
  selCols: "Select available columns",
  startDate: "Start date",
  endDate: "End date",
  type2: "Report yype",
  distance: "Total distance traveled",
  usedfuel: "Total fuel used",
  drivefuel: "Fuel consumption on drive",
  ralentifuel: "Fuel consumption idle",
  rendbruto: "Gross performance",
  consumeperhour: "Consumption per hour",
  timedriving: "Driving time",
  timeralenti: "Idle time",
  finalfuel: "Final fuel",
  timepto: "PTO time",
  percentPto: "% PTO",
  fuelpto: "PTO fuel",
  speedpromedy: "Average speed",
  speedmax: "Max speed",
  rpmexcess: "RPMs in excess",
  maxrpm: "Max RPMs",
  exceptions: "In transit incidents",
  finaldistance: "Final distance",
  await: "Working...",
  confirmation: "Finished report",
  wrongConfirmation: "Unable to create the report. Try again.",
  CreatedBy: "Created by",
  Status: "Status",
  MessageReport:
    "The time to create the report will depend on the number of vehicles and selected dates",
  PerformanceReport: "Performance report",
  ExceptionReport: "Exceptions report",
  //Filter vehicles
  filterVehicles: "Filter",
  select: "Vehicles selection",
  dealer: "Distributor",
  client: "Client",
  account: "Account",
  group: "Group",
  all: "All",
  save: "Save",
  //Menu app drawer
  titleRep: "Summarized reports",
  titleABalance: "Comparation per period",
  titleExceptions: "In transit incidents",
  dashboard: "Overview",
  commands: "Commands",
  exit: "Exit",
  logout: "Logout",
  tracts: "ALERTRUCK",
  noName: "No name",
  accountM: "Manage",
  Users: "Users",
  entailment: "Entailment",
  //Commands

  //Dashboard
  vehiclesD: "Vehicles",
  totalFuel: "Total used fuel",
  totalRalentiFuel: "Total used fuel idle",
  exceptionsHome: "In transit incidents",
  totalDistance: "Total distance traveled",
  totalPerformance: "Average performance",
  TotalEmptyFuel: "Total fuel idle",
  Totaldistancetraveled: "Total traveled distance",
  today: "Today",
  last: "Last",
  days: "Days",
  to: "to",
  consumption: "Consumption",

//Alertruck vehicles information
  vehicleInformation: "Vehicle information",
  informationInThePeriod: "Information in the period selected",
  
  //Charts dashboard
  moreRalenti: "Fuel idle", /////
  topRalenti: "10 Topmost vehicles in fuel consumption",
  emptyFuel: "Fuel idle",
  fuel: "Fuel",
  rangeFuel: "Performance range", /////
  menorRendimiento: "Performances",
  topPerformance: "10 Lowest vehicles in fuel performance",
  rendimientoFuel: "Fuel efficiency",
  engineTime: "Engine running total time",
  drive: "Driving",
  stop: "Idle",
  ralenti: "Ralenti",
  moreTimeEngine: "Motor usage idle time", ///
  topEngine: "10 Topmost vehicles in motor usage",
  hour: "Hours",
  timeEngineOn: "Engine running time",
  velocityExcess: "Speeding",
  frenadoBrusco: "Sudden braking",
  excesoFreno: "Strong braking",
  aceleracionB: "Sudden acceleration",
  excessClutch: "Excess clutch",
  moreExcept: "10 Topmost in transit incidents",
  topExceptions: "10 Topmost vehicles in driving faults",
  compSemanal: "Weekly comparation",
  emtyHours: "Idle engine hours",
  driveHours: "Driving hours",
  engineOnWeek: "Engine running weekly comparation",
  distancRoad: "Traveled distance",
  distance: "Distance",
  weekDistances: "Traveled distance weekly comparation",
  rendi: "Performance",
  weekRend: "Perfomance weekly comparation",
  time: "Time",
  //Account Billings

  //Exceptions
  ExcessSpeed: "Speeding",
  BrusqueAccelerations: "Sudden acceleration cases",
  Brushesbrakes: "Sudden braking cases",
  ExcessMotorLoad: "Motor load excess",
  ExcessRPM: "RPMs in excess",
  ExcessClutch: "Clutch in excess",
  SharpTurns: "Sudden turnout",
  ExcessEngineHours: "Running motor hours in excess",
  ExcessEngineVacuum: "Idle motor hours in excess",
  NumberExceptions: "Faults quantity",

  //Session
  session: "Your session has expired",
  //AccountManager page
  addUser: "Add a new user",
  edit: "Modify",
  dateInitial: "Date of joining",
  actions: "Actions",
  active: "Active",
  inactive: "Inactive",
  deleteUser: "Are you sure to delete the selected user?",
  editUser: "Name",
  newUser: "New user",
  editUserTitle: "Modify user",
  permissions: "Not enough privileges. Contact the admin",
  selectDealer: "Select a distributor",
  //Settings
  personalization: "Customization",
  darkMode: "Dark mode",
  changeLogo: "Change logo",
  changeTheme: "Change theme",
  SystemofUnits: "Units",
  distance: "Distance",
  volume: "Volume",
  temperature: "Temperature",
  initialSettings: "Initial settings",
  //charts
  printChart: "Print chart",
  downloadPNG: "Download PNG image",
  downloadJPEG: "Download JPEG image",
  downloadPDF: "Download PDF document",
  downloadSVG: "Download SVG image",
  liters: "Liters",
  gallons: "Gallons",
  errorDashboard: "No data. Try again later",

  //Exceptions titles
  ev445: "RPMs in excess",
  ev446: "Engine off in less than X seconds",
  ev447: "Excess of clutch time while moving",
  ev448: "Excess of clutch time idle",
  ev449: "Excess of braking time",
  ev450: "Excess of motor load",
  ev451: "High idle percentage",
  ev452: "Sudden acceleration",
  ev453: "Sudden braking",
  ev454: "Low cruise control percentage",
  ev455: "Idle time alert",
  ev456: "Insufficient rest time",
  ev457: "Medium speeding",
  ev458: "Severe speeding",
  ev459: "Low fuel economy",
  ev464: "Rest detected alert",
  ev463: "End of PTO",
  ev466: "Average motor high load alert",
  ev467: "Error code detection",
  ev470: "Bus de datos desconectado",
  ev471: "Bus de datos reconectado",
  ev472: "Bus de datos erróneo seleccionado",
  ev479: "Start of consumption by PTO in motion",
  ev480: "End of consumption by PTO in motion",
  ev481: "Curve at high speed", // -
  ev482: "Idle time alert summary",
  ev483: "Cruise control activation", // -
  ev484: "Cruise control deactivation", // -
  otros: "Others",

  //Offline
  offline: "No internet connection",
  online: "Internet connection",
  later: "No internet connection, try later",

  loadingData: "Loading data, this operation may take some time...",
  lateData: "The operation is taking longer than normal, please wait... ",
  loadingTable: "Loading... Please wait",

  noReport: "Please select a report",

  //Errores de servidor
  autorization: "Unauthorized user",
  error400: "An error occurred, try later",

  errorFechas:
    "The selected period must not exceed 31 days of operation. Please check...",
  selectDate: "Date selection",
  invalidDate: "Invalid date period",
  userSelect: "Select user please",

  existinguser: "User selects already exists",
  addeduser: "User added",
  userSelect: "Select user please",
  from: "From",
  to: "To",
  notExist: "User not exist",
  docNotExist: "Report not found",
  notExistData: "No data",
  addToList: "Add to the list",
  deleteVehicle: "Delete to the list",
  quickList: "Quick list",

  sizeImage: "The maximum image weight is 5 MB",
  alertImage: "The image exceeds 5 MB",
  deleteAllReports: "Are you sure to delete all selected reports?",

  invalidName: "Invalid name of report",

  //entailment
  manageoperators: "Manage operators",
  addoperator: "Add operator",
  entail: "entail",
  noEntail: "No entail",
  operator: "Operator",
  license: "License",
  type: "Type",
  licenseExpiration: "License expiration",
  address: "Address",
  registrationDate: "Registration Date",
  bonding: "Bonding",
  administration: "Administration",
  link: "Link",
  unlink: "Unlink",
  operators: "Operators",
  newOperator: "New operator",
  typeoflicense: "Type of license",
  expirationDate: "Expiration date",
  required: "Required",
  editOperator: "Edit operator",
  deleteConfirmOp: "Are you sure to delete the selected operator?",
  restrictionTravel:
    "This operator cannot be removed because you are traveling",
  restrictionMovil:
    "It is not possible to remove this operator because you have a linked mobile",
  selectMobileEquipment: "Select mobile equipment",
  other: "Other",

  //Mobiles
  manageMobileTeams: "Manage mobile teams",
  mobiles: "Mobiles",
  mobileEquipment: "Mobile equipment",
  model: "Model",
  OS: "OS",
  addEquipment: "Add equiment",
  number: "Número",
  brand: "Brand",
  operativeSystem: "Operative system",
  scanPhone: "Scan on phone to register",
  newMobileEquipment: "New mobile equipment",
  editMobileTeam: "Edit mobile team",
  deleteConfirmMo: "Are you sure to delete this mobile?",
  restrictionTravelM:
    "It is not possible to delete this mobile equipment because it is on the road",
  restrictionOperator:
    "This mobile equipment cannot be removed because it has a linked operator",
  selectAnOperator: "Select an operator",
  serialNumber: "Serial number",

  //Trafico
  traffic: "Traffic",
  inTravel: "On route",
  noTrip: "Traveling, no route",
  stopped: "Parked",
  outOfService: "Out of service",
  operatingStates: "Operating states",
  allStates: "All the states",
  vehicle: "Vehicle",
  lastPosition: "Last position",
  date: "Date",
  idleTime: "Idle time",
  statusT: "Status",
  newTrip: "New trip",
  inProgress: "In progress",
  finalize: "Finalize",
  dateT: "Date",
  assignTrip: "Assign trip",
  travels: "Travels",
  nameOfTheTrip: "Name of the trip",
  pathName: "Path name",
  origin: "Origin",
  destination: "Destination",
  start: "Start",
  finish: "Finish",
  editTrip: "Edit trip",
  map: "Map",
  updatePosition: "Update position",
  deleteTravel: "Are you sure to delete this trip?",
  finishTravel: "Are you sure to finish this trip?",
  //Carriers
  businessName: "Business name",
  serviceType: "Service type",
  modality: "Modality",
  addCarrier: "Add carrier",
  noCarrier: "Please select a carrier",
  unknown: "Unknown",
  cargoGeneral: "General cargo",
  hazardousMaterials: "Hazardous materials and waste",
  alimentaryGrade: "Alimentary grade",
  consolidated: "Consolidated",
  fullCar: "Full car",
  carrierManagement: "Carrier management",
  typeOfServices: "Type of services",
  selectContact: "Select contact",
  phone: "Phone",
  contact: "Contact",
  deleteConfirmCa: "Are you sure to remove this carrier?",
  deleteAllCarriers: "Are you sure you want to delete all selected carriers?",

  monitoring: "Monitoring",
  newCarrier: "New carrier",
  editCarrier: "Edit carrier",
  add: "Add",
  seeContacts: "See contacts",
  currentlimitTime: "The chosen time passes the current time",
  lessStartDate: "The start date must be less than the end date",
  dateRange:
    "The selected period must not exceed 7 days of operation. Please check...",
  error409Trip: "Vehicle/Driver with trip in progress",
  //DetailsAndTable
  drivingConsume: "Driving consume",
  consumptionIdle: "Consumption idle",
  consumePTO: "Consume PTO",
  motorUsage: "PTO Motor usage",
  drivingMotorUsage: "Driving motor usage",
  motorUsageIdle: "Motor usage idle",
  performance: "Performance",
  //In transit incidents details
  driving: "Driving",
  operation: "Vehicle operation",
  logistics: "Logistics",
  diagnosticUnit: "Diagnostics",
  categories: "Categories",
  //performance
  performancePerTime: "Period performance",
  tripEfficiency: "Trip efficiency",
  location: "Location",
  event: "Event",
  eventDetails: "Event details",
  exceptionsReport: "In transit incidents report",
  calGlobal: "Global calculations",
  efficiencyAnalisis: "Efficiency analysis",
  maxSpeed: "Maximum speed",
  avgSpeed: "Average speed",
  rpmMax: "Maximum Rpm",
  rpmAvg: "Average Rpm",
  breakTime: "Break time",
  tripTime: "Trip time",
  motorUsag: "Time engine usage",
  expDash: "Export dashboard",
  expExcel: "Export excel",
  odometer: "Odometer",
  motorEfficiency: "Motor efficiency analysis",
  velProm: "Average vehicle speed",
  velPromRPM: "Average engine speed in Rpm",
  cargaProm: "Average motor load percentage",
  pedalProm: "Average accelerator pedal position",
  vel: "Speed",
  percent: "Percent",
  consult: "Consult",
  compare: "Compare",
  FuelConsumed: "Fuel consumed",
  EngineUsageTime: "Engine usage time",
  BadHabits: "Bad driving habits detected",
  FuelControlCrucero: "Cruise mode fuel",
  TimeControlCrucero: "Cruise mode time",
  DistanceControlCrucero: "Cruise mode distance",
  cruiseActive: "Active crontrol cruise",
  cruiseInactive: "Inactive control cruise",
  BrakeCounter: "Brake",
  ClutchCounter: "Clutch excess",
  RoughBrakeCounter: "Brake excess",
  ExcessRpmCounter: "RPM excess",
  notAvailable: "Not available",
  threshold: "Threshold",
  ptoElapsed: "PTO time elapsed",
  engineShutOff: "Time the engine was shut off",
  clutchTime: "Clutch time",
  thresholdSpeed: "Threshold speed",
  thresholdTime: "Threshold time",
  brakeTime: "Brake time",
  initialSpeed: "Initial speed",
  finalSpeed: "Final speed",
  excessLoadT: "Excess load time",
  loadMax: "Maximum load",
  umbralPercentage: "Threshold percentage",
  ralentiTime: "Idle time",
  ralentiF: "Idle fuel",
  accelerationMax: "Maximum acceleration detected",
  decelerationMax: "Maximum deceleration",
  percentageCC: "Cruise control percentage",
  fuelEconomy: "Fuel economy",
  timeAt: "Time at",
  initialTotFuel: "Initial total fuel",
  avgLoadPercentage: "Average load percentage detected",
  thresholdAvgLoadP: "Average load percentage threshold",
  initialFuelIdle: "Initial fuel idle",
  frequency: "Frencuency",
  busReal: "Bus real detectado",
  selectedBus: "Bus selected",
  //comparative
  comparative: "Comparative",
  efficiency: "Efficiency",
  tripAnalysis: "Efficiency analysis by trips",
  tripInTransitIncidents: "In transit incidents by trips",
  distribution: "Distribution of in transit incidents",
  trip: "Trip",
  timeEngine: "Engine usage time",
  fuelConsumed: "Fuel consumed",
  tripDuration: "Trip duration",
  minSpeed: "Min speed",
  minRpm: "Min RPM",
  maxRpmm: "Max RPM",
  AvgMotorLoad: "Average motor load",
  maxMotorLoad: "Carga de motor máxima",
  noTrips: "Period without assigned trip",
  noTripSelected: "Please select a trip",
  fuelConsum: "Fuel consume",
  vol: "Volume",
  finalOdometer: "Final odometer",
  finalFuel: "Final Fuel",
  excededData: "The information requested is to much for the local storage",
  PerformancePerHour: "Performance per hour",
  DrivingPerformance: "Driving Performance",
  maxSpeedDate: "Max speed date",
  lat: "Lattitude",
  lon: "Longitude",
  descripcion: "Description",
  engineHistory: "Engine usage history",
  tripsHistory: "Trips history",
  //individual fuel
  individualFuel: "Individual fuel",
  selectVehicle: "Select vehicle",
  update: "Update",
  newFrom: "From",
  newTo: "To",
  recentActivity: "Recent activity",
  magnitudeOfChange: "Magnitude of change",
  selectPeriod: "Select period",
  seeMore: "See more",
  noVehicle: "No vehicle selected",
  locationUnavailable: "Location unavailable",
  noDataAR: "There is no data for recent activity",
  noDataPerformance: "There is no data for performance",
  noDataFP: "There is no data for performance and recent activity",
  noDataPerformance: "There is no data for performance",
  noDataRL:
    "There is no data for the last level of fuel reported by the vehicle selected",
  legendPerformance: "Average performance",
  noResultsFound: "No results found for the given location",
  geoFailed: "The reverse geocoding failed due to: ",
  loadingLocation: "Loading location... Please wait",
  noDetailsData: "There is no data available",
  load: "Load",
  discharge: "Discharge",
  periodSelected: "Period selected",
  effectivePeriod: "Effective period",
  modifyPeriod: "The period consulted will be modified",
  //descripcion de eventos
  distanceTraveled: "Distance traveled during the event",
  timeElapsed: "Time elapsed during the event",
  maxVal: "Maximum value detected",
  minTime: "Minimum shutdown time",
  detectedShutdown: "Detected shutdown time",
  timeDetected: "Time detected",
  speedAtTheStart: "Speed at the start of the event",
  speedAtTheEnd: "Speed at the end of the event",
  thresholdLoadP: "Threshold load percentage",
  percentageOfMaxLoad: "Percentage of maximum load detected",
  tripThresholdTime: "Trip threshold time",
  idleTimeElapsed: "Idle time elapsed since the start of the trip",
  fuelConsumedIdleMark: "Fuel consumed at idle from the mark",
  thresholdAcceleration: "Threshold acceleration",
  thresholdBraking: "Threshold braking",
  maxBrakingD: "Maximum braking detected",
  percentageDetected: "Percentage detected",
  drivingThresholdTime: "Driving threshold time",
  drivingTimeElapsed: "Driving time elapsed",
  minPerformance: "Minimum performance",
  performanceDetected: "Performance detected",
  totalFuelConsumption: "Total fuel consumption",
  fuelConsumptionIdle: "Fuel consumption idle",
  thresholdAvgLoad: "Threshold average load",
  //rastreo
  tracking: "Tracking",
  timeWT: "Time without transmitting",
  checkStatus: "Check status",
  centerOnMap: "Center on map",
  sendCommand: "Send command",
  seeAct: "See activity",
  seeStatus: "See status",
  loadingTextForTable: "Loading... Please wait",
  addressNotAvailable: "Address not available",
  plates: "Plates",
  year: "Year",
  color: "Color",
  category: "Category",
  comments: "Comments",
  operatingState: "Operating state",
  gps: "GPS",
  server: "Server",
  position: "Position",
  battery: "Battery",
  gsm: "GSM",
  realPosition: "Real position",
  connectedToServer: "Connected to server",
  autoReports: "Auto reports",
  switch: "Ignition switch",
  ignitionLocked: "Ignition locked",
  ignitionunLocked: "Ignition unlocked",
  panicButton: "Panic button",
  engineLocked: "Engine locked",
  supportButton: "Support button",
  lightSiren: "Lights/Siren",
  helpButton: "Help button",
  doorsLocked: "Doors locked",
  batteryConnected: "Battery connected",
  doorsUnlocked: "Doors unlocked",
  activateSiren: "Activate siren",
  desactivateSiren: "Desactivate siren",
  activity: "Activity",
  engine: "Engine",
  connection: "Connection",
  geoReference: "Geographic reference",
  iO: "Inputs/Outputs",
  vehAttributes: "Vehicle attributes",
  reports: "Reports",
  preferences: "Preferences",
  confirmedCommand: "Confirmed command",
  confirmEngineLock: "Confirm engine lock",
  lastTransmission: "Last transmission",
  onGoing: "On going",
  stopped: "Stopped",
  noteVehState: "Note: It was moving in the same place",
  valueNotAvailable: "Value not available at the moment",
  distanceNotAvailable: "Distance not available at the moment",
  durationNotAvailable: "Duration not available at the moment",
  fuelNotAvailable: "Fuel not available at the moment",
  since: "Since",
  noResponse: "No response",
  altavozOn: "Activate speaker",
  altvozOff: "Deactivate speaker",
  callOn: "Activate call",
  tmReportsOn: "Activate reports (TM-FIL-DIST)",
  tmReportsOff: "Deactivate reports (TM-FIL-DIST)",
  reportVel: "Report for speeding",
  reportIgnicion: "Ignition switch report",
  repStartStop: "Report Stopped / Running",
  repGpsState: "Gps status report",
  getImei: "Check IMEI",
  getSimData: "Check SIM Card data",
  lockEngine: "Lock engine",
  unlockEngine: "Unlock engine",
  resetES: "Restore E/S",
  resetButtons: "Restore buttons",
  freeText: "Free text",
  confirmCommand: "Confirm send command",
  noActivityData: "No data for the selected period",
  selectCommand: "Select a command",
  timeWithOutPto: "Drive / Iddle",
  ralentiFuelConsumed: "Idle fuel consumed",
  ralentiTimeConsumed: "Elapsed idle time",
  predDays: "Predefined days",
  noInfo: "No information to display",
  totalOdometer: "Total odometer",
  theTotalFuel: "Total fuel",
  totalTime: "Total time",
  avgCruisingSpeed: "Average cruising speed",
  callBy: "Call origin",
  callByMe: "Call to device",
  callByDevice: "Receive call from device",
  speakerOn: "Activate speaker",
  searchVehicles: "Search vehicles around",
  minutes: "Minutes",
  //VEHICLES AT
  parametersConfig: "Parameters configuration",
  configTemplates: "Configuration templates",
  consultProgress: "Consult progress",
  movilId: "Movil ID",
  nick: "Nick",
  config: "Configuration",
  lastConfig: "Last configuration",
  updated: "Updated",
  configProcess: "Configuration in process",
  failedToUpdate: "Failed to update",
  default: "Default",
  templates: "Templates",
  allGroups: "All groups",
  setUp: "Set up",
  loadingAdress: "Loading address... please wait",
  vehiclesInProg: "Vehicles in progress",
  
  //TEMPLATES AT
  newTemplate: "New template",
  assign: "Assign",
  templateName: "Template name",
  creationDate: "Creation date",
  editionDate: "Edition date",
  confirmationT: "Confirmation",
  deleteTemplate: "Are you sure to delete the selected template?",
  deleteTemplates: "Are you sure to delete the selected templates?",
  editTemplate: "Edit template",
  templateAssignment: "Template assignment",
  saveTemplate: "Dou you want to save the template __TEMPLATENAME__?",
  saveTemplateChanges: "Do you want to save the changes to the template __TEMPLATENAME__?",

  //VERIFY CONFIG
  verifyConfig: "Verify configuration",
  sync: "Sync",
  templateContent: "Template content",
  vehicleContent: "Vehicle content",
  distinct: "Distinct",
  editAccording: "Edit according to",
  syncAccording: "Sync according to",
  periodicReports: "Periodic reports",
  odometerReport: "Odometer report",
  fuelReport: "Fuel report",
  timeReport: "Time report",
  stoppedVehicleReport: "Stopped vehicle report",
  vehicleRunningReport: "Vehicle running report",
  highIdlePercentage: "High idle percentage",
  alertExcessiveIdlingTime: "Alert/excessive idling time",
  vehicleOperation: "Vehicle operation",
  ptoStopped: "PTO stopped",
  quickPowerOff: "Quick power off",
  activated: "Activated",
  disabled: "Disabled",
  defaultTemplate: "Default template",
  contentOf: "Content of",
  mix: "Mix",
  with: "With",
  withThe: "With the",
  overwritingThe: "When overwriting the",
  requiredTo: "It is required to reconfigure the vehicles that are assigned to his template",
  toContinue: "Do you want to continue?",
  preliminaryContent: "Preliminary content",
  parameter: "Parameter",
  split: "Split",
  //CONFIGURATION PROGRESS
  configTracking: "Configuration tracking",
  details: "Details",
  configured: "Configured",
  notConfigured: "No configured",
  finished: "Finished",
  applicationDate: "Application date",
  timeElapsedInConfig: "Time elapsed",
  configProgress: "Configuration progress",
  configuring: "Configuring",
  //NOTIFICATIONS
  notifications: "Notifications",
  actionCenter: "Action center"
};

export default en;
